import React from 'react';
import { FaUsers, FaProjectDiagram, FaGraduationCap, FaBriefcase, FaSignOutAlt, FaChartLine, FaCode, FaEnvelope } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { logoutUser } from '../../../actions/loginAction';
import './Dashboard.css';

const Dashboard = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logoutUser());
    history.push('/login');
  };

  const menuItems = [
    {
      title: 'Education',
      icon: <FaGraduationCap className="menu-icon" />,
      path: '/education',
      description: 'Manage academic qualifications',
      count: '4 Items',
      color: 'education'
    },
    {
      title: 'Experience',
      icon: <FaBriefcase className="menu-icon" />,
      path: '/experience',
      description: 'Track work experience',
      count: '3 Items',
      color: 'experience'
    },
    {
      title: 'Projects',
      icon: <FaProjectDiagram className="menu-icon" />,
      path: '/project',
      description: 'Portfolio projects',
      count: '6 Projects',
      color: 'projects'
    },
    {
      title: 'Skills',
      icon: <FaCode className="menu-icon" />,
      path: '/skill',
      description: 'Technical skills',
      count: '8 Skills',
      color: 'skills'
    },
    {
      title: 'Messages',
      icon: <FaEnvelope className="menu-icon" />,
      path: '/messages',
      description: 'Contact messages',
      count: '2 New',
      color: 'messages'
    },
    {
      title: 'Profile',
      icon: <FaUsers className="menu-icon" />,
      path: '/profile',
      description: 'Personal information',
      count: 'View Details',
      color: 'profile'
    }
  ];

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div className="header-content">
          <h1>Welcome Back, Admin!</h1>
          <p className="header-subtitle">Manage your portfolio content and settings</p>
        </div>
        <button className="logout-btn" onClick={handleLogout}>
          <FaSignOutAlt /> Logout
        </button>
      </div>

      <div className="overview-section">
        <h2 className="section-title">
          <FaChartLine className="section-icon" />
          Portfolio Overview
        </h2>
        <div className="stats-container">
          {menuItems.map((item, index) => (
            <div 
              key={index} 
              className={`stat-card ${item.color}-card`}
              onClick={() => history.push(item.path)}
            >
              <div className={`stat-icon ${item.color}`}>
                {item.icon}
              </div>
              <div className="stat-details">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <span className="stat-count">{item.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 